import React from "react";
import Cta from "@/components/ui-kit/Cta";
import { Reveal } from "@/components/motion/Reveal";
import { Eyebrow } from "@/components/ui-kit/Section";

export default function FinalCta({
  eyebrow = "Get started",
  title = "Stop doing tax math by hand.",
  subtitle = "Set your percentage once. ETAP routes your set aside the moment income lands, and shows you exactly where every dollar went.",
  primaryLabel = "Start Free Setup",
  primaryTo = "/get-started",
  secondaryLabel = "Talk to our agency team",
  secondaryTo = "/agencies",
  location = "final-cta",
}) {
  return (
    <section className="px-5 pb-20 sm:px-6 lg:px-8 lg:pb-28">
      <div className="grain relative mx-auto max-w-7xl overflow-hidden rounded-[2rem] bg-etap-deep-900 px-6 py-16 shadow-etap-xl sm:px-12 sm:py-20">
        {/* Master background image with dark scrim */}
        <img
          src="/media/cta-bg.jpg"
          alt=""
          aria-hidden="true"
          loading="lazy"
          className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-55"
        />
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              "linear-gradient(100deg, rgba(13,28,42,0.96) 0%, rgba(13,28,42,0.82) 45%, rgba(29,57,83,0.6) 100%)",
          }}
        />
        {/* Mint accent glow */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-etap-mint-400 opacity-20 blur-3xl"
        />
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -bottom-20 -left-10 h-64 w-64 rounded-full bg-etap-primary-400 opacity-20 blur-3xl"
        />
        <div className="relative max-w-2xl">
          <Reveal>
            <Eyebrow onDeep>{eyebrow}</Eyebrow>
            <h2 className="mt-4 font-display text-[clamp(2rem,4vw,3.25rem)] font-bold leading-[1.08] tracking-tight text-white">
              {title}
            </h2>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-etap-deep-100">{subtitle}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Cta to={primaryTo} variant="mint" size="lg" location={`${location}-primary`} withArrow testId="final-cta-primary">
                {primaryLabel}
              </Cta>
              <Cta to={secondaryTo} variant="onDeepOutline" size="lg" location={`${location}-secondary`} testId="final-cta-secondary">
                {secondaryLabel}
              </Cta>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
